module.exports = __webpack_public_path__ + "images/the-giver-00c374dd8a0713894aae1f6bca67fc1c.png";